<!--
 * @Author: vince
 * @Date: 2021-08-18 14:26:14
 * @LastEditors: vince
 * @LastEditTime: 2021-09-04 17:34:28
 * @Description: 
-->
<template>
	<el-select
		size="small"
		v-if="controlType == 'select'"
		value-key="grade"
		:multiple="multiple"
		:loading="loading"
		v-model="valueTemp"
		filterable
		:filter-method="filterMethod"
		placeholder="请选择年级"
		clearable
		@change="onChange"
	>
		<el-option v-for="item in options" :value="item" :key="item.grade" :label="item.gradeName"></el-option>
	</el-select>
	<el-checkbox-group v-else-if="controlType=='checkbox'" v-model="checkTemp" @change="onChange">
		<el-checkbox v-for="(item,index) in options" :key="index" :label="item">{{item.gradeName}}</el-checkbox>
	</el-checkbox-group>
</template>

<script>
import { mapGetters } from "vuex";
import { postData } from "../../http/fetch.js";
export default {
	name: "gradeSelector",
	model: {
		prop: "value",
		event: "change"
	},
	data() {
		return {
			loading: false,
			checkTemp: [],
			valueTemp: null,
			options: []
		};
	},
	watch: {
		value(v) {
			this.valueTemp = v;
			this.checkTemp = v;
		}
	},
	props: {
		multiple: {
			type: Boolean,
			default: false
		},
		controlType: {
			type: String,
			default: "select"
		},
		value: {
			type: Object | Array
		}
	},
	computed: {
		...mapGetters(["schoolCode"])
	},
	created() {
		//this.valueTemp = this.value;
		this.getGradeList();
	},
	methods: {
		onChange(v) {
			this.$emit("change", v);
		},
		async getGradeList() {
			this.loading = true;
			return new Promise((resolve, reject) => {
				postData("/school/getGradeList", { schoolCode: this.schoolCode })
					.then(res => {
						let list = [];
						if (res.length) {
							list = res;
							this.options = res;
							resolve(list);
						} else {
							this.options = [];
							reject();
						}
					})
					.catch(e => {
						reject(e);
					})
					.finally(() => {
						this.loading = false;
					});
			});
		},
		async filterMethod(node, query) {
			if (this.options.length == 0) {
				await this.getGradeList();
			}
			return false;
		}
	}
};
</script>

<style>
</style>